// Set when any API answer says the account is blocked (ACCOUNT_BLOCKED: at sign-in with the right
// password, or on a blocked member's session; apps/api/src/lib/account-gate.ts). The blocked-account
// screen (components/AccountGate.tsx) takes the place of the site while it's set.
import { useSyncExternalStore } from 'react';

export interface AccountBlock {
  /** Why, as staff chose to tell the member, in their language; null when no reason was given. */
  reason: string | null;
  /** Staff's own message to the member, as written. */
  note: string | null;
  /** Their session is still there: the screen offers "Log out" (else "Back", from sign-in). */
  signedIn: boolean;
}

let current: AccountBlock | null = null;
const subs = new Set<() => void>();
const emit = () => subs.forEach((f) => f());

const text = (v: unknown) => (typeof v === 'string' && v.trim() ? v : null);

/** From an ACCOUNT_BLOCKED answer's `block` (anything unreadable shows the screen without it). */
export function reportAccountBlocked(block: unknown) {
  const b = (block && typeof block === 'object' ? block : {}) as Record<string, unknown>;
  current = { reason: text(b.reason), note: text(b.note), signedIn: b.signedIn !== false };
  emit();
}

export function clearAccountBlocked() {
  current = null;
  emit();
}

export function useAccountBlock(): AccountBlock | null {
  return useSyncExternalStore(
    (f) => (subs.add(f), () => subs.delete(f)),
    () => current,
    () => null,
  );
}
